<div class="container">
    <div class="history-card">
        <div class="header">
            <h2 i18n class="title">HISTORY</h2>
        </div>
        <div class="history-container">
            @for (historyNum of displayedHistory; track $index) {
                <div class="number-box" [class]="historyNum.backgroundClass">
                    {{ historyNum.displayValue }}
                </div>
            }
        </div>
    </div>
</div>
